import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';

function Login() {
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);
  const { login } = useAuth();
  const navigate = useNavigate();

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError('');
    setLoading(true);

    try {
      await login(email, password);
      navigate('/dashboard');
    } catch (err) {
      setError(err.response?.data?.error || 'Login failed');
    } finally {
      setLoading(false);
    }
  };

  const handleBackToHome = () => {
    navigate('/');
  };

  return (
    <div className="container">
      <div className="card" style={{ maxWidth: '450px', margin: '100px auto' }}>
        <h1>Login to ViRaffle</h1>

        <div style={{
          background: '#e3f2fd',
          padding: '15px',
          borderRadius: '8px',
          marginBottom: '25px',
          border: '1px solid #2196f3'
        }}>
          <p style={{ margin: 0, fontSize: '0.9rem', color: '#1976d2' }}>
            ℹ️ <strong>First time here?</strong> You must install the app from the GHL Marketplace first.
          </p>
        </div>

        <form onSubmit={handleSubmit}>
          <label>Email</label>
          <input
            type="email"
            value={email}
            onChange={(e) => setEmail(e.target.value)}
            required
          />

          <label>Password</label>
          <input
            type="password"
            value={password}
            onChange={(e) => setPassword(e.target.value)}
            required
          />

          {error && (
            <div className="error" style={{
              background: '#ffebee',
              color: '#c62828',
              padding: '12px',
              borderRadius: '6px',
              marginBottom: '15px',
              border: '1px solid #ef5350'
            }}>
              {error}
              {error.includes('not found') || error.includes('Invalid') ? (
                <div style={{ marginTop: '10px', fontSize: '0.85rem' }}>
                  💡 Not registered yet? <a
                    href="/"
                    style={{ color: '#1976d2', textDecoration: 'underline' }}
                  >
                    Install from GHL Marketplace
                  </a>
                </div>
              ) : null}
            </div>
          )}

          <button type="submit" disabled={loading} style={{ marginBottom: '15px' }}>
            {loading ? 'Logging in...' : 'Login'}
          </button>
        </form>

        <div style={{
          textAlign: 'center',
          paddingTop: '20px',
          borderTop: '1px solid #e0e0e0'
        }}>
          <button
            onClick={handleBackToHome}
            style={{
              background: 'transparent',
              color: '#667eea',
              border: '2px solid #667eea',
              padding: '12px 24px',
              borderRadius: '6px',
              cursor: 'pointer',
              fontSize: '1rem',
              fontWeight: '500',
              transition: 'all 0.2s'
            }}
            onMouseOver={(e) => {
              e.target.style.background = '#667eea';
              e.target.style.color = 'white';
            }}
            onMouseOut={(e) => {
              e.target.style.background = 'transparent';
              e.target.style.color = '#667eea';
            }}
          >
            ← Back to Home
          </button>

          <p style={{
            marginTop: '20px',
            fontSize: '0.85rem',
            color: '#666'
          }}>
            Need to install the app?{' '}
            <a
              href="/"
              style={{ color: '#667eea', textDecoration: 'underline' }}
            >
              Get it from GHL Marketplace
            </a>
          </p>
        </div>
      </div>
    </div>
  );
}

export default Login;
